import { ERoomType } from '../../../packages/api-models/common/json_query';

// Утилита для получения лейбла типа комнаты
export function getRoomTypeLabel(roomType: ERoomType): string {
  switch (roomType) {
    case ERoomType.Studio:
      return 'Студия';
    case ERoomType.FlatOneRoom:
      return '1-комнатная';
    case ERoomType.FlatTwoRooms:
      return '2-комнатная';
    case ERoomType.FlatThreeRooms:
      return '3-комнатная';
    case ERoomType.FlatFourRooms:
      return '4-комнатная';
    case ERoomType.FlatFiveRooms:
      return '5-комнатная';
    case ERoomType.FlatManyRooms:
      return '6+ комнат';
    default:
      return roomType.toString();
  }
}

// Утилита для получения лейблов нескольких типов комнат
export function getRoomTypeLabels(roomTypes: ERoomType[]): string {
  return roomTypes.map(getRoomTypeLabel).join(', ');
}
